import { VenueUpdatePortfolioInput } from '../../graphql/API';
import { venueUpdatePortfolioContent } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueUpdatePortfolioContentApi = async (
  input: VenueUpdatePortfolioInput,
): Promise<void> => {
  await executeGql<void>(venueUpdatePortfolioContent, { input });
};
